import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeMusicToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeMusicToYoutube}
            sections={<PairSyncGuideContent sourceKey="youtubeMusic" destKey="youtube" />}
        />
    );
}
